import { PatientBackendMockModule } from './patient-backend-mock.module';

export {
  PatientBackendMockModule
} from './patient-backend-mock.module';

export { PatientBackendMockService } from './patient-backend.service.mock.service';

